import { useCallback, useState } from 'react';

import { Trans, useTranslation } from '@lyearn/i18n';
import { AlertDialog } from '@lyearn/molecules';
import { Typography, useSnackbar } from '@lyearn/ui';
import useResponse from '@/hooks/useResponse';

import useFileMutations from '../../../hooks/useFileMutations';
import { DialogProps } from '../types';

export const DeleteSection = ({ onClose, folderId }: DialogProps) => {
  const { t } = useTranslation();

  const { showSnackbar } = useSnackbar();
  const { deleteFile } = useFileMutations();
  const { handleResponse } = useResponse();

  const [isLoading, setIsLoading] = useState(false);

  const onDelete = useCallback(async () => {
    if (!folderId?.length) {
      return;
    }

    setIsLoading(true);

    const data = await deleteFile({ data: { fileId: folderId } });

    handleResponse({
      condition: !!data.data?.deleteFile?.success,
      onSuccess: () => {
        showSnackbar({
          message: t('Task:Section.SectionDeleted'),
        });
      },
    });

    setIsLoading(false);
    onClose();
  }, [deleteFile, folderId, handleResponse, showSnackbar, t, onClose]);

  return (
    <AlertDialog
      header={{
        title: t('Task:Section.DeleteSection'),
        description: (
          <Trans
            components={{ strong: <Typography variant="label-02" /> }}
            i18nKey="Task:Section.DeleteSectionDescription"
          />
        ),
      }}
      primaryAction={{
        appearance: 'danger',
        label: t('Common:Actions.Delete'),
        onClick: onDelete,
        loading: isLoading,
        disabled: isLoading,
      }}
      onClose={onClose}></AlertDialog>
  );
};
